import React, {
  FC, useCallback, useEffect, useState,
} from 'react';

import { AffectedQuestions } from '../../commons/AffectedQuestions';
import { QBackButton } from '../../commons/QBackButton';
import { QConfirmButton } from '../../commons/QConfirmButton';
import { QHeader } from '../../commons/QHeader';
import { Q6Form, Q6Response } from './form';
import { Row } from 'components/base/Row';

import { BudgetQuestionCodes } from 'modules/budget/data/budgetQuestionCodes';
import { useBudget } from 'modules/budget/hooks/useBudget';
import { Address } from 'modules/budget/models/Address';
import { ILocation } from 'modules/budget/models/Location/types';

export const Q6: FC<Record<string, unknown>> = () => {
  const question = BudgetQuestionCodes.Q6;
  const { RespondQuestion } = useBudget();

  const [dismissService, setDismissService] = useState<boolean>();
  const [selectedAddress, setSelectedAddress] = useState<Address | null>(null);
  const [selectedLocation, setSelectedLocation] = useState<ILocation | null>(null);
  const [enabledReply, setEnabledReply] = useState<boolean>();
  const [autorespond, setautorespond] = useState<boolean>(false);

  useEffect(
    () => {
      const isFullFilled = selectedAddress?.isFullFilled();
      setEnabledReply(dismissService === true
         || (dismissService === false && isFullFilled && Boolean(selectedLocation)));
    },
    [dismissService, selectedAddress, selectedLocation],
  );

  const response = useCallback(
    ({ gotoSummary }) => {
      if (dismissService === false) {
        if (selectedAddress && selectedLocation) {
          RespondQuestion({
            gotoSummary,
            question,
            response: {
              address: selectedAddress,
              location: selectedLocation,
            },
          });
        }
      } else {
        RespondQuestion({
          gotoSummary,
          question,
        });
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dismissService, selectedAddress, selectedLocation],
  );

  useEffect(
    () => {
      if (autorespond && enabledReply) {
        response({ gotoSummary: false });
      }
    },
    [autorespond, enabledReply, response],
  );

  const onChange = useCallback(
    (responseData: Q6Response) => {
      setDismissService(responseData.dismissService);
      setSelectedAddress(responseData.address);
      setSelectedLocation(responseData.location);
      setautorespond(responseData.autorespond);
    },
    [],
  );

  return (
    <React.Fragment>
      <QHeader question={question} />
      <Q6Form
        question={BudgetQuestionCodes.Q6}
        onChange={onChange}
      />
      <Row justifyContent="space-between">
        <QBackButton question={question} />
        <Row
          className="f-question-actions"
          justifyContent="flex-end"
        >
          <AffectedQuestions
            question={question}
            response={{
              address: selectedAddress,
              location: selectedLocation,
            }}
          />
          <QConfirmButton
            disabled={!enabledReply}
            question={question}
            onClick={(payload) => response({ gotoSummary: payload?.gotoSummary })}
          />
        </Row>
      </Row>
    </React.Fragment>
  );
};
